import React, { createContext, useContext, useState } from "react";

export const GoalListContext = createContext();

export const useGoalList = () => useContext(GoalListContext);

export const GoalListProvider = ({ children }) => {
  const [goals, setGoals] = useState([]);

  const addGoal = (goal) => {
    setGoals((prevGoals) => [...prevGoals, goal]);
  };

  const removeGoal = (goalID) => {
    setGoals((prevGoals) => prevGoals.filter((goal) => goal.goalID !== goalID));
  };

  return (
    <GoalListContext.Provider
      value={{
        goals,
        setGoals,
        addGoal,
        removeGoal,
      }}
    >
      {children}
    </GoalListContext.Provider>
  );
};
